import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { captureAttribution } from "@/lib/attribution";

export default function AttributionCapture() {
  const location = useLocation();

  useEffect(() => {
    captureAttribution(new URLSearchParams(location.search));
  }, [location.search]);

  return null;
}
